export const getBenchTimelinePeriodCount = breakPoint => {
  switch (breakPoint) {
    case 'xl':
      return 7;
    case 'lg':
    case 'md':
      return 4;
    case 'sm':
    case 'xs':
      return 3;
    default:
      return 3;
  }
};
